import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import SpreadTheWordPage from "@/pages/SpreadTheWordPage";
import GratitudeJournalPage from "@/pages/GratitudeJournalPage";
import ShopifyStorePage from "@/pages/ShopifyStorePage";
import ComingSoonPage from "@/pages/ComingSoonPage";
import ContactPage from "@/pages/ContactPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import TermsOfServicePage from "@/pages/TermsOfServicePage";
import ShippingPolicyPage from "@/pages/ShippingPolicyPage";
import ReturnPolicyPage from "@/pages/ReturnPolicyPage";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/spread-the-word" element={<SpreadTheWordPage />} />
          <Route path="/gratitude-journal" element={<GratitudeJournalPage />} />
          <Route path="/shop" element={<ShopifyStorePage />} />
          <Route path="/coming-soon" element={<ComingSoonPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-service" element={<TermsOfServicePage />} />
          <Route path="/shipping-policy" element={<ShippingPolicyPage />} />
          <Route path="/return-policy" element={<ReturnPolicyPage />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
